import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mutlBrand',
      component: ()=> import(`@/views/index.vue`)
    },
    {
      path: '/kc',
      name: 'kc',
      component: ()=> import(`@/views/kc/index.vue`)
    },
    {
      path: '/et',
      name: 'et',
      component: ()=> import(`@/views/et/index.vue`)
    },
    {
      path: '/cg',
      name: 'cg',
      component: ()=> import(`@/views/cg/index.vue`)
    },
    {
      path: '/ht',
      name: 'ht',
      component: ()=> import(`@/views/ht/index.vue`)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js